// src/components/planning/ServiceCard/components/ServiceCardHeader.tsx
import React from 'react';
import { Clock } from 'lucide-react';
import { ServiceCardHeaderProps } from '../types';
import { formatDate } from '../utils/dateUtils';
import styles from '../styles/components.module.css';

// Helper function to format time from "HH:MM" to "H:MM AM/PM"
const formatTime = (time?: string): string | null => {
  if (!time) return null;

  const [hours, minutes] = time.split(':').map(Number);
  if (isNaN(hours) || isNaN(minutes)) return null;

  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;

  return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
};

export const ServiceCardHeader: React.FC<ServiceCardHeaderProps> = ({
  liturgyDate,
  liturgyName,
  liturgicalSeason,
  time,
  onHistoryClick
}) => (
  <div className={styles.cardHeader}>
    <div className={styles.cardHeaderContent}>
      <h3>{formatDate(liturgyDate)}</h3>
      {(liturgyName || liturgicalSeason || time) && (
        <p>
          {liturgicalSeason && <span className={styles.seasonTag}>{liturgicalSeason}</span>}
          {liturgyName}
          {liturgyName && time && ' · '}
          {time && formatTime(time)}
        </p>
      )}
    </div>
    {onHistoryClick && liturgyName && (
      <button
        className={styles.historyBtn}
        onClick={onHistoryClick}
        title="View music history for this Sunday"
        aria-label="View music history"
      >
        <Clock size={16} />
      </button>
    )}
  </div>
);